export const HNFSR_LOYALTY_EXPIRESIN = 15; // 15 minutes

export default {
  HNFSR_LOYALTY_EXPIRESIN,
};
